import React from 'react';
import { motion } from 'framer-motion';
export function IdentifySection() {
  const items = ['No puedes dejar de ver pornografía aunque quieras', 'Interfiere con tus compromisos, trabajo o relaciones', 'Lo mantienes en secreto absoluto', 'Vives un ciclo constante de vergüenza y culpa', 'Piensas en pornografía incluso cuando no la estás viendo'];
  return <section className="bg-dark py-24" data-id="element-90">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-92">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 uppercase" data-id="element-93">
            ¿Alguna de estas situaciones te describe?
          </h2>

          <div className="space-y-4 mb-12" data-id="element-94">
            {items.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} className="flex items-center gap-4 p-4 hover:bg-dark-card rounded-lg transition-colors" data-id="element-95">
                <div className="w-6 h-6 rounded border-2 border-accent flex items-center justify-center flex-shrink-0 bg-accent/10" data-id="element-96">
                  <div className="w-3 h-3 bg-accent rounded-sm" data-id="element-97"></div>
                </div>
                <p className="text-lg text-gray-300" data-id="element-98">{item}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-99">
            <p className="text-2xl font-bold text-accent" data-id="element-100">
              Si marcaste aunque sea una, este libro es para ti.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}